import { IRequester, requester } from "src/libraries/requester";
import { IResponse } from "src/libraries/requester/IRequester/IResponse";
import { ILinks, links } from "src/Links";
import { IVacancies } from "./IVacancies";
import { GetVacanciesDto } from "./dto/list-vacancies-dto";

class VacanciesService {
    constructor(
        private requester: IRequester,
        private links: ILinks,
    ) { }

    create = async (body: FormData): Promise<IResponse<IVacancies>> => {
        try {
            const response = await this.requester.postFormData(this.links.vacancies, body);
            return response;
        } catch (error) {
            console.warn('VacanciesService -> create: ', this.links.vacancies, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    list = async (body?: GetVacanciesDto): Promise<IResponse<{ rows: IVacancies[]; count: number; }>> => {
        try {
            const url = new URL(this.links.vacancies);
            if (body) {
                Object.keys(body).forEach(key => url.searchParams.append(key, body[key]));
            }
            const response = await this.requester.get(url.href);
            return response;
        } catch (error) {
            console.warn('VacanciesService -> list: ', this.links.vacancies, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    update = async (id: number, body: FormData): Promise<IResponse<IVacancies>> => {
        try {
            const url = this.links.vacancies + '/' + id;
            const response = await this.requester.patchFormData(url, body);
            return response;
        } catch (error) {
            console.warn('VacanciesService -> update: ', this.links.vacancies, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    get = async (id: number | string): Promise<IResponse<IVacancies>> => {
        try {
            const response = await this.requester.get(this.links.vacancies + '/' + id);
            return response;
        } catch (error) {
            console.warn('VacanciesService -> get: ', this.links.vacancies, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    delete = async (id: number): Promise<IResponse<any>> => {
        try {
            const response = await this.requester.delete(this.links.vacancies + id);
            return response;
        } catch (error) {
            console.warn('VacanciesService -> delete: ', this.links.vacancies, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

}

export const vacanciesService = new VacanciesService(requester, links);